import BlockDisplay from './component/BlockDisplay';
import ErrorPopup from './component/ErrorPopup';
import NoticePopup from './component/NoticePopup';
import Notification from './component/Notification';
import SessionMonitor from './component/session/SessionMonitor';
import RootRouterView from './view/RootRouterView';

const App = ({ error }) => {
    return (
        <div className='App'>
            <BlockDisplay />
            <Notification />
            <RootRouterView />
            <ErrorPopup />
            <NoticePopup />
            <SessionMonitor />
        </div>
    );
};

export default App;
